import * as entity from '@common/domain/entities/Requisition'
import { ViewType, WorkflowType, FieldType, WhereExpressionType } from '../../../framework/core/Enums';
import * as app from '@framework/app';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { IDataEndPoint, IFieldOptions } from '../../../framework/interfaces/IEntity';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { Permissions } from '../../../config/AppEnums';
import { IDetailComponent } from '../../../framework/components/mf-blade/mf-blade.component';
import { ActionDialogComponent } from '../../../modules/shared/components/action-dialog/action-dialog.component';
import { PartialEmailsSelectorComponent } from '../../../modules/requisition/components/partial-emails-selector/partial-emails-selector.component';
import { appSettings } from '../../../modules/shared/components/appSettings';
import { IPropertyFilter } from '../../formbuilder/PropertyFilter';
import { FormBuilderControl } from '../../formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '../../formbuilder/FormBuilderControlType';
import { RequisitionItemList } from './RequisitionItem';
import { RequisitionItemListPageComponent } from '../../../framework/components/mf-list-page/ListPageComponentsExt';
import { RfqSelectItemsComponent } from '../../../modules/requisition/components/rfq-select-items/rfq-select-items.component';
import { SelectApproverComponent } from '../../../modules/requisition/components/select-approver/select-approver.component';
import { BulkHierarchyComponent } from '../../../modules/requisition/components/bulk-hierarchy/bulk-hierarchy.component';
import { ReqItemExcelImportComponent } from '../../../modules/requisition/components/req-item-excel-import/req-item-excel-import.component';
import { CreateReqCopyComponent } from '../../../modules/requisition/components/create-req-copy/create-req-copy.component';

export class RequisitionEndPoints extends entity.RequisitionEndPoints {
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/detail/" + serviceCommand.context.entityId }, method: "GET" };
  exportToExcel?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyPOCreatedQueryExport" }, method: "POST" };
}



export class RequisitionFormFields extends entity.RequisitionFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(this.indexOf(this.status), 1)
      this.splice(this.indexOf(this.latestRequisitionWorkflowId), 1);
      this.splice(this.indexOf(this.organisationId), 1);
      this.date.readOnly = true;
      this.date.name = "Date Created";
      this.uniqueId.readOnly = true;

      this.date.show = function (entity) {
        return entity.id
      }
      this.uniqueId.show = function (entity) {
        return entity.id
      }
      this.isStore.name = "Is store Requisition";
      this.isStore.viewType = ViewType.YesNo;
      this.isStore.show = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.CreateStoreRequisition);
      }
      this.isStore.change = function (o, n, entity, context) {
        if (entity.isStore) {
          entity.deliveryAddress = '53 Galaxy Ave, Frankenwald, Sandton, 2065';
        }
      }

      this.splice(this.indexOf(this.isStore), 1);
      this.unshift(this.isStore);

      this.isPettyCash.viewType = ViewType.YesNo;
      this.isPettyCash.show = function (entity, auth) {
        return !entity.isStore;
      }

      this.splice(this.indexOf(this.isPettyCash), 1);
      this.unshift(this.isPettyCash);

      this.contactNumber.viewType = ViewType.AutoComplete;
      this.contactNumber.searchEndPoint = { url: app.config.controllerRouteRoot + "/requisition/smartAutocomplete/VwContactPersonAndNumber/" };
      this.contactNumber.dataDisplayField = "contactNumber";
      this.contactNumber.dataIdField = "contactNumber";
      this.contactNumber.dontForceAutoCompleteSelect = true;

      this.contactPerson.viewType = ViewType.AutoComplete;
      this.contactPerson.searchEndPoint = { url: app.config.controllerRouteRoot + "/requisition/smartAutocomplete/VwContactPersons/" };
      this.contactPerson.dataDisplayField = "contactPerson";
      this.contactPerson.dataIdField = "contactPerson";
      this.contactPerson.dontForceAutoCompleteSelect = true;

      this.warehouseId.viewType = ViewType.Dropdown;
      this.warehouseId.searchEndPoint = { url: app.config.controllerRouteRoot + "/warehouse/smartAutocomplete" };
      this.warehouseId.dataEndPoint = { url: app.config.controllerRouteRoot + "/warehouse/dropdown" };
      this.warehouseId.dataDisplayField = "name";
      this.warehouseId.dataIdField = "id";
      this.warehouseId.show = function (entity, auth) {
        if (entity.isStore) {
          return true;
        }
      }

      var sites: IFieldOptions = {
        name: "Site address lookup",
        fieldType: FieldType.String,
        viewType: ViewType.AutoComplete,
        searchEndPoint: { url: app.config.controllerRouteRoot + "/site/smartAutocomplete/" },
        dataDisplayField: "name",
        field: "siteLookup",
        dataIdField: "address",
        show:
          function (entity) {
            return !entity.id && !entity.isStore;
          },

      }
      var division: IFieldOptions = {
        name: "Division",
        fieldType: FieldType.String,
        viewType: ViewType.String,
       readOnly:true,
        field: "division"

      }
      this.unshift(division)
      sites.change = function (o, n, entity, context) {
        entity.deliveryAddress = n.value;
      }
      //this.push(sites);

      this.splice(this.indexOf(this.deliveryAddress), 1);
      this.push(this.deliveryAddress);
      this.deliveryAddress.required = true;
      this.deliveryAddress.viewType = ViewType.AutoComplete;
      this.deliveryAddress.searchEndPoint = { url: app.config.controllerRouteRoot + "/requisition/smartAutocomplete/VwDeliveryAddresses/" };
      this.deliveryAddress.dataDisplayField = "deliveryAddress";
      this.deliveryAddress.dataIdField = "deliveryAddress";
      this.deliveryAddress.dontForceAutoCompleteSelect = true;
      this.splice(this.indexOf(this.createdByUserId), 1);
      this.date.viewType = ViewType.Date;
      this.poComments.viewType = ViewType.Text;
      this.poComments.show = function (entity, auth) {
          if (!auth)
            return false;
        return auth.currentOrganisationId && auth.currentOrganisationId.toLowerCase() == '1bc2a837-bf83-4a26-8206-92ed9ed0ce79';
      }
      this.isReservationOrder.viewType = ViewType.YesNo;
      this.isReservationOrder.show = function (entity, auth) {
        if (!auth)
          return false;
        return auth.currentOrganisationId && auth.currentOrganisationId.toLowerCase() == '1bc2a837-bf83-4a26-8206-92ed9ed0ce79';
      }

      
    } catch  { }
  }
}

export enum ReqActions {
  AddNote,
  CreateCopy,
  CancelReq,
  SendToProcurementOfficer,
  ProcurementOfficerSendBackToCreator,
  SendToApprover,
  SendForProcessing,
  ProcessReq,
  Complete,
  WorkflowRejectedForCorrection,
  SendToManager,
  PrintPO,
  UnprintPO,
  WorkflowProcurementAdminApprovalRequired,
  Export,
  ProcurementOfficerSendToContractManager
}


export class RequisitionItemReportListBlade {


  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Download selected", click: function (context, event) {

      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.AddNote, context, entityId, newItem, formTriggerIndex, entityData);
      }
    }

  ]
}
export class RequisitionListBladeSetup {
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Export Selected", click: function (context) {
        var table = context.getFormInstanceByIndex(0).lazyTable;
        let filterArr = new Array();


        if (table.staticFilters)
          table.staticFilters.filter(function (o) {
            return o.filterValue != '' && o.filterValue != null
          })
            .forEach(o => {
              filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
            });
        let filterObject = JSON.parse(table._currentFilterObject);
        filterObject.StartCount = 0;
        filterObject.PageSize = 9999999;
        filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

        var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyPOCreatedQueryExport" }, method: "POST" };
        var self = context;


        self.apiService.exec({
          data: filterObject,
          endPoint: download,
          context: self,
          success: function (data) {
            const link = document.createElement('a');
            link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
            link.setAttribute('visibility', 'hidden');
            link.click();
          },
          error: function (error) {
            self.loading = false;
            self.messageService.danger('Could not Export', 'Action');
          }
        })
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return false;//!context.authService.hasAnyPermissions(Permissions.ProcurementAdmin);
      }
    },
  ]
}

export class RequisitionBladeSetup {

  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
    }
    if (prop.listIndex == 1) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(1);
    }
  }
  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {
    if (formIndex == 0) {
      if (context.entityData.latestWorkflow && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRejectedForCorrection) {
        if (context.authService.userProfile) {
          if (!context.authService.hasAnyPermissions(Permissions.RequisitionApproval, Permissions.ProcurementApproval, Permissions.StockRequisition)) {
            context.parent.componentInstance[1].component.makeFormReadOnly(true);
            //context.parent.componentInstance[3].component.makeFormReadOnly(true);
          }
          else {
            context.parent.componentInstance[1].component.makeFormReadOnly(false);
            //context.parent.componentInstance[3].component.makeFormReadOnly(false);
          }
        } else {
          context.authService.userProfileObserver.subscribe(o => {
            if (!context.authService.hasAnyPermissions(Permissions.RequisitionApproval, Permissions.ProcurementApproval, Permissions.StockRequisition)) {
              context.parent.componentInstance[1].component.makeFormReadOnly(true);
              //context.parent.componentInstance[3].component.makeFormReadOnly(true);
            }
            else {
              context.parent.componentInstance[1].component.makeFormReadOnly(false);
              //context.parent.componentInstance[3].component.makeFormReadOnly(false);
            }
          })
        }

        if (context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessed || context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessing
          || context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowGRND || context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowCompleted)
          context.parent.selectedMenuItemIndex = 2;
        else context.parent.selectedMenuItemIndex = 1;
      }
      else {
        context.parent.componentInstance[1].component.makeFormReadOnly(false);
        context.parent.componentInstance[3].component.makeFormReadOnly(false);
      }
    }


  }

  public onMenuActionOverlayClick = function (context) {
    context.loading = true;
    var postObj = { comments: context.overlayPanelData.comments, emails: [], approverId: null };
    if (context.overlayPanelData && context.overlayPanelData.sendEmails) {
      postObj.emails = context.overlayPanelData.emails;
    }
    if (context.overlayPanelData && context.overlayPanelData.approverId) {
      postObj.approverId = context.overlayPanelData.approverId;
    }
    context.showActionDialog = false;
    if (context.overlayPanelData.note) {
      context.apiService.post(`/api/requisition/addNote/${context.overlayPanelIdentifier}/${context.entityId}`, postObj)
        .subscribe(o => {
          context.loading = false;
          context.messageService.success('Saved successfully', 'Action');
          context.parent.getBladeByIndex(0).reloadFormByIndex(0);
          context.reloadFormByIndex(0);
          context.reloadFormByIndex(4);
          context.reloadFormByIndex(2);
          context.reloadFormByIndex(1);
        }, err => {
          context.loading = false;
          context.messageService.danger('Could not save. ' + err.error, 'Action', { duration: 10000 });
        })
    }
    else {

      context.apiService.post(`/api/requisition/createWorkflow/${context.overlayPanelIdentifier}/${context.entityId}`, postObj)
        .subscribe(o => {
          context.loading = false;
          context.messageService.success('Saved successfully', 'Action');
          context.parent.getBladeByIndex(0).reloadFormByIndex(0);
          context.reloadFormByIndex(0);
          context.reloadFormByIndex(4);
          context.reloadFormByIndex(2);
          context.reloadFormByIndex(1);
          if (context.overlayPanelData && context.overlayPanelData.doNotCloseBlade) {

          }
          else context.closeBlade();
          if (o && o != null) {
            const ref = context.dialogService.open(ActionDialogComponent, {
              data: {
                buttonActions: [
                  {
                    iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                      ref.close();
                    }
                  }
                ],
                message: `${o.msg}`,
              },
              header: `${o.header}`,
              width: '50%'
            });
          }
        }, err => {
          context.loading = false;
          if (err && err.error && err.error.errors) {
            const ref = this.dialogService.open(ActionDialogComponent, {
              data: {
                buttonActions: [
                  {
                    iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                      ref.close();
                    }
                  }
                ],
                message: err.error.errors,
              },
              header: 'Could not save',
              width: '50%'
            });
          }
          else
            context.messageService.danger('Could not save. ' + err.error, 'Action', { duration: 10000 });
        })
    }
  }

  public getPanelSubtitleFunc = function (context) {
    var form = context.getFormInstanceByIndex(0);
    if (!form || !context.getFormInstanceByIndex(0).entityData || !context.getFormInstanceByIndex(0).entityData.latestWorkflow || !context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow)
      return '';
    return 'Current Status: ' + context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow.name + (context.getFormInstanceByIndex(0).entityData.assignedOfficer ? " | Assigned officer: " + context.getFormInstanceByIndex(0).entityData.assignedOfficer : "");
  }

  public isActionHidden = function (reqAction: ReqActions, context, entityId, newItem, formTriggerIndex, entityData) {
    if (newItem)
      return true;
    if (formTriggerIndex != 0)
      return;
    if (!context || !context.authService || !context.authService.userProfile)
      return;
    if (!context.entityData.latestWorkflow)
      return;

    switch (reqAction) {
      case ReqActions.Export: {
       // if (context.entityData.latestWorkflow && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated) {
         return false;
       // }
        break;
      }
      case ReqActions.AddNote: {
        if (context.entityData.latestWorkflow && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated) {
          if (!context.authService.hasAnyPermissions(Permissions.RequisitionApproval, Permissions.ProcurementApproval, Permissions.StockRequisition)) {
            return true;
          }
          else return false;
        }
        break;
      }

      case ReqActions.CreateCopy: {
        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.ProcurementAdmin, Permissions.StockRequisition))
          return false;
        if (context.authService.userProfile && (entityData.createdByUserId == context.authService.userProfile.sub || entityData.linkedUserId == context.authService.userProfile.sub))
          return false;
        return true;
        break;
      }
      case ReqActions.CancelReq: {

if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
return false;

        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.ProcurementAdmin))
            return false;
        }


        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRequisitionCreated || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowContractManagerApprovalRequested || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrection) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowContractManagerApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
              return false;
            if (context.authService.userProfile && entityData.contractManagerUserIds.indexOf(context.authService.userProfile.sub) == -1)
              return true;
            else {
              return false;
            }
          }
          else return false;
        }
        return true;
        break;
      }
      case ReqActions.SendToProcurementOfficer: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrection || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRequisitionCreated || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowContractManagerApprovalRequested) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin) && entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrection)
            return false;
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowContractManagerApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
              return false;
            if (context.authService.userProfile && entityData.contractManagerUserIds.indexOf(context.authService.userProfile.sub) == -1)
              return true;
            else {
              return false;
            }
          }
          else if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrection && context.authService.userProfile && (entityData.createdByUserId != context.authService.userProfile.sub && entityData.linkedUserId != context.authService.userProfile.sub))
            return true;
          else return false;
        }
        return true;
        break;
      }

      case ReqActions.ProcurementOfficerSendBackToCreator: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
            return false;
        }
        
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowContractManagerApprovalRequested) {
          if (context.authService.userProfile && (entityData.createdByUserId == context.authService.userProfile.sub || entityData.linkedUserId == context.authService.userProfile.sub))
            return true;
          else return false;
        }
        return true;
        break;
      }
      case ReqActions.ProcurementOfficerSendToContractManager: {
        if (entityData.contractManagerApproved && entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
            return false;
        }
        return true;
        break;
      }
      case ReqActions.SendToApprover: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer || entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRequisitionCreated) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
            return false;
        }
        return true;
        break;
      }
      case ReqActions.WorkflowProcurementAdminApprovalRequired: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementAdminApprovalRequired) {
          if (context.authService.hasAnyPermissions(Permissions.LargeReqAdminApproval,Permissions.ProcurementAdmin ))
            return false;
        }
        return true;
        break;
      }
        
      case ReqActions.PrintPO: {
        var workflowsThatCanPrint = [WorkflowType.WorkflowProcessing,
        WorkflowType.WorkflowProcessed,
        WorkflowType.WorkflowCompleted, WorkflowType.WorkflowGRND,
        WorkflowType.WorkflowItemGRND,
        WorkflowType.WorkflowItemPOGenerated,
        WorkflowType.WorkflowItemComplete,
        WorkflowType.WorkflowPartialItemGRND,
        WorkflowType.WorkflowPartialItemPOGenerated]
        if (workflowsThatCanPrint.indexOf(entityData.latestWorkflow.workflowType) != -1 && !entityData.poPrinted && context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
          return false;
        return true;
        break;
      }
      case ReqActions.UnprintPO: {
        var workflowsThatCanPrint = [WorkflowType.WorkflowProcessing,
        WorkflowType.WorkflowProcessed,
        WorkflowType.WorkflowCompleted, WorkflowType.WorkflowGRND,
        WorkflowType.WorkflowItemGRND,
        WorkflowType.WorkflowItemPOGenerated,
        WorkflowType.WorkflowItemComplete,
        WorkflowType.WorkflowPartialItemGRND,
        WorkflowType.WorkflowPartialItemPOGenerated]
        if (workflowsThatCanPrint.indexOf(entityData.latestWorkflow.workflowType) != -1 && entityData.poPrinted && context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
          return false;
        return true;
        break;
      }
      case ReqActions.SendForProcessing: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowApprovalRequested) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
            return false;
          if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval) && entityData.approverId == context.authService.userProfile.sub)
            return false;
        }
        return true;
        break;
      }

      case ReqActions.ProcessReq: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowApproved) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
            return false;
        }
        return true;
        break;
      }


      case ReqActions.Complete: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcessing) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
            return false;
        }
        return true;
        break;
      }

      case ReqActions.WorkflowRejectedForCorrection: {
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementAdminApprovalRequired) {
          if (context.authService.hasAnyPermissions(Permissions.LargeReqAdminApproval))
            return false;
        }
        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowApprovalRequested) {
          if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
            return false;
          if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval) && entityData.approverId == context.authService.userProfile.sub)
            return false;
        }

        return true;
        break;
      }


    }


  }

  public menuActions: Array<IDetailComponent> = [

    {
      index: -2, displayName: "Set #SIV", click: function (context, event) {
        const ref = context.dialogService.open(BulkHierarchyComponent, {
          data: {
            requisition: context.getFormInstanceByIndex(0).entityData,
            requisitionId: context.entityId,
            items: context.getFormInstanceByIndex(1).items.data,
            siv: true
          },
          header: `Set #SIV`,
          width: '80%'
        });
        ref.onClose.subscribe((emails) => {
          if (emails) {
            context.reloadFormByIndex(0);
            context.reloadFormByIndex(1);
            context.reloadFormByIndex(2);
            context.reloadFormByIndex(4);
          }

        });
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;

        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;
        if (context.authService.hasAnyPermissions(Permissions.StockRequisition)) {
          if (!context.entityData.warehouseUserIds)
            return true;

          if (context.entityData.warehouseUserIds.indexOf(context.authService.userProfile.sub) != -1)
            return false;
          return true;
        }
        if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
          return false;
        return true;
      }, icon: "fas fa-shopping-cart"
    },
    {
      index: 0, displayName: "Excel Import", click: function (context, event) {
        const ref = context.dialogService.open(ReqItemExcelImportComponent, {
          data: {
            requisition: context.getFormInstanceByIndex(0).entityData,
            requisitionId: context.entityId,
            items: context.getFormInstanceByIndex(1).items.data
          },
          header: `Excel Import`,
          width: '80%'
        });
        ref.onClose.subscribe((emails) => {
          if (emails) {
            context.reloadFormByIndex(1);
            context.reloadFormByIndex(2);
          }

        });
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        debugger;
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;

        if (entityData.latestWorkflow.workflowType != WorkflowType.WorkflowProcurementOfficer
          && entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated)
          return true;
        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
          return false;
        if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
          return false;
      }, icon: "fas fa-pencil"
    },

    {
      index: -2, displayName: "Bulk Update", click: function (context, event) {
        const ref = context.dialogService.open(BulkHierarchyComponent, {
          data: {
            requisition: context.getFormInstanceByIndex(0).entityData,
            requisitionId: context.entityId,
            items: context.getFormInstanceByIndex(1).items.data
          },
          header: `Bulk Update`,
          width: '80%'
        });
        ref.onClose.subscribe((emails) => {
          if (emails) {
            context.reloadFormByIndex(1);
            context.reloadFormByIndex(2);
          }

        });
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;

        if (entityData.latestWorkflow.workflowType != WorkflowType.WorkflowProcurementOfficer)
          return true;
        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
          return false;
      }, icon: "fas fa-pencil"
    },
    {
      index: -1, displayName: "Assign to me", click: function (context, event) {
        context.loading = true;
        context.apiService.get(`/api/requisition/assignOfficer/${context.entityId}`)
          .subscribe(user => {
            context.loading = false;
            context.reloadFormByIndex(0)
            context.parent.getBladeByIndex(0).reloadFormByIndex(0);

          }, err => {
            context.messageService.danger("Could not assign officer", "Action");
            context.loading = false;
          });
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;

        if (entityData.officerId == context.authService.userProfile.sub)
          return true;
        if (entityData.latestWorkflow.workflowType != WorkflowType.WorkflowProcurementOfficer)
          return true;
        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
          return false;
      }, icon: "fas fa-user"
    },
    {
      index: 1, displayName: "Export", click: function (context, event) {
        context.loading = true;
        context.apiService.get(`/api/requisition/exportReqItems/${context.entityId}`)
          .subscribe(data => {
            context.loading = false;
            context.messageService.success('Export has started download', 'Action');
            context.loading = false;
            const link = document.createElement('a');
            link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
            link.setAttribute('visibility', 'hidden');
            link.click();

          }, err => {
            context.messageService.danger("Could not export", "Action");
            context.loading = false;
          });
      },

      
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.Export, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fa fa-file-excel"
    },
    {
      index: 0, displayName: "Add note", click: function (context, event) {
        context.overlayPanelData = { doNotCloseBlade: true, note: true };
        context.overlayPanelIdentifier = context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType;
        context.panelHeader = "Add note";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.AddNote, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-sticky-note"
    },
    {
      index: 1, displayName: "Create copy", click: function (context, event) {
            const ref = context.dialogService.open(CreateReqCopyComponent, {
                      data: {
                        requisitionId: context.entityId,
                        scope:context
                      },
                      header: `Create copy of requisition`,
                      width: '50%'
                    });
                    ref.onClose.subscribe((newId) => {
                        if (newId)
                context.navigateToIndex(1, newId, 1);

                    });


        
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.CreateCopy, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-copy"
    },
    {
      index: 4, displayName: "Cancel Requisition", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowCancelled;
        context.panelHeader = "Cancel Requisition";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.CancelReq, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-times"
    },
    {
      index: 1, displayName: "Approve Large Req", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowApprovalRequested;
        context.panelHeader = "Approve Large Req";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.WorkflowProcurementAdminApprovalRequired, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 1, displayName: "Send for processing", click: function (context, event) {
        var itemsApproved = context.getFormInstanceByIndex(1).items
        if (itemsApproved.length == 0) {
          context.confirmationService.confirm({
            message: 'No Items added for procurement. Are you sure that you would like to continue?',
            header: 'No Items added for procurement',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowProcurementOfficer;
              context.panelHeader = "Send for processing";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        }
        else {
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowProcurementOfficer;
          context.panelHeader = "Send for processing";
          context.showActionDialog = true;
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.SendToProcurementOfficer, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 2, displayName: "Send back for correction", click: function (context, event) {
        var itemsApproved = context.getFormInstanceByIndex(1).items
        if (itemsApproved.length == 0) {
          context.confirmationService.confirm({
            message: 'No Items added for procurement. Are you sure that you would like to continue?',
            header: 'No Items added for procurement',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowRejectedForCorrection;
              context.panelHeader = "Send back for correction";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        }
        else {
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowRejectedForCorrection;
          context.panelHeader = "Send back for correction";
          context.showActionDialog = true;
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.ProcurementOfficerSendBackToCreator, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-reply"
    },
    {
      index: 3, displayName: "Send to Contract Manager", click: function (context, event) {
      
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowProcurementOfficer;
          context.panelHeader = "Send to Contract Manager";
          context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.ProcurementOfficerSendToContractManager, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-reply"
    },
    {
      index: 10, displayName: "Print PO's", click: function (context, event) {

        //context.loading = true;
        var links = document.createElement('a');
        document.body.appendChild(links);
        links.download = "";
        links.target = "_blank";
        links.href = context.apiService.appSettings.apiServiceAddress + `/api/requisition/printPos/${context.entityId}`;
        links.click();
        document.body.removeChild(links);

      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;
        var workflowsThatCanPrint = [WorkflowType.WorkflowProcessing,
        WorkflowType.WorkflowProcessed,
        WorkflowType.WorkflowCompleted, WorkflowType.WorkflowGRND,
        WorkflowType.WorkflowItemGRND,
        WorkflowType.WorkflowItemPOGenerated,
        WorkflowType.WorkflowItemComplete,
        WorkflowType.WorkflowPartialItemGRND,
        WorkflowType.WorkflowPartialItemPOGenerated]
        return workflowsThatCanPrint.indexOf(context.entityData.latestWorkflow.workflowType) == -1;
      }, icon: "fas fa-print"
    },
    , {
      index: 10, displayName: "Set PO Printed", click: function (context, event) {
        context.apiService.post(`/api/requisition/updatePOPrinted/${context.entityId}/true`, {})
          .subscribe(o => {
            context.loading = false;
            context.parent.getBladeByIndex(0).reloadFormByIndex(0);
            context.parent.getBladeByIndex(1).reloadFormByIndex(1);
            context.reloadFormByIndex(0);
            context.reloadFormByIndex(2);
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          })
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;
        return new RequisitionBladeSetup().isActionHidden(ReqActions.PrintPO, context, entityId, newItem, 0, context.entityData);
      }, icon: "fas fa-print"
    },
    {
      index: 10, displayName: "Set PO NOT Printed", click: function (context, event) {
        context.apiService.post(`/api/requisition/updatePOPrinted/${context.entityId}/false`, {})
          .subscribe(o => {
            context.loading = false;
            context.parent.getBladeByIndex(0).reloadFormByIndex(0);
            context.parent.getBladeByIndex(1).reloadFormByIndex(1);
            context.reloadFormByIndex(0);
            context.reloadFormByIndex(2);
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          })
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;
        return new RequisitionBladeSetup().isActionHidden(ReqActions.UnprintPO, context, entityId, newItem, 0, context.entityData);
      }, icon: "fas fa-print"
    },
    {
      index: -1, displayName: "Approve all & send for processing", click: function (context, event) {

        var itemsNotApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApprovalRequested
        });
        if (itemsNotApproved.length > 0) {
          context.loading = true;
          context.apiService.post(`/api/requisitionItem/createWorkflows/${WorkflowType.WorkflowItemApproved}`, {
            reqItemIds: itemsNotApproved.map(o => {
              return o.id
            })
          })
            .subscribe(o => {
              context.loading = false;
              context.parent.getBladeByIndex(0).reloadFormByIndex(0);
              context.parent.getBladeByIndex(1).reloadFormByIndex(1);
              context.reloadFormByIndex(0);
              context.reloadFormByIndex(2);
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowApproved;
              context.panelHeader = "Send for processing";
              context.showActionDialog = true;
            }, err => {
              context.loading = false;
              context.messageService.danger('Could not save', 'Action');
            })
        }
        else {
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowApproved;
          context.panelHeader = "Send for processing";
          context.showActionDialog = true;
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (!context || !entityData)
          return true;
        var reqForm = context.parent.getFormInstanceByIndex(0);
        var reqItemList = context.parent.getFormInstanceByIndex(1);
        if (!reqForm.entityData || !reqItemList.items || !reqItemList.items.data)
          return true;
        var itemsNotApproved = reqItemList.items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApprovalRequested
        });
        if (itemsNotApproved.length == 0)
          return true;
        return new RequisitionBladeSetup().isActionHidden(ReqActions.SendForProcessing, reqForm, entityId, newItem, 0, reqForm.entityData);
      }, icon: "fas fa-check-double"
    },
    {
      index: 1, displayName: "Send back for correction", click: function (context, event) {
        var itemsApproved = context.getFormInstanceByIndex(1).items
        if (itemsApproved.length == 0) {
          context.confirmationService.confirm({
            message: 'No Items added for procurement. Are you sure that you would like to continue?',
            header: 'No Items added for procurement',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowRejectedForCorrectionOfficer;
              context.panelHeader = "Send back for correction";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        }
        else {
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowRejectedForCorrectionOfficer;
          context.panelHeader = "Send back for correction";
          context.showActionDialog = true;
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.WorkflowRejectedForCorrection, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-reply"
    },
    {
      index: 1, displayName: "Send to Approver", click: function (context, event) {
        var itemsApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApprovalRequested
            || o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApproved
        });
        var itemsNotApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemPending
        });
        var selectApprover = function () {
          const ref = context.dialogService.open(SelectApproverComponent, {
            data: {
              requisitionId: context.entityId,
              items: context.getFormInstanceByIndex(1).items.data
            },
            header: `Select Approver to asssign to`,
            width: '50%'
          });
          ref.onClose.subscribe((approver) => {
            if (approver) {
              context.overlayPanelData = { approverId: approver };
              context.overlayPanelIdentifier = WorkflowType.WorkflowApprovalRequested;
              context.panelHeader = "Send to Approver";
              context.showActionDialog = true;
            }
            else {
              context.messageService.danger('Could not send for processing. No approver selected', 'Action');
            }
          });
        }
        if (itemsApproved.length == 0 && itemsNotApproved.length == 0) {
          context.confirmationService.confirm({
            message: 'No Items added for approver. Are you sure that you would like to continue?',
            header: 'No Items added for approver',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              selectApprover()
            },
            reject: () => {

            }
          });
        }
        else if (itemsNotApproved.length > 0 || (itemsApproved.length == 0 && itemsNotApproved.length > 0)) {
          context.confirmationService.confirm({
            message: 'Not all items have been requested for approval. Are you sure that you would like to continue?',
            header: 'Not all items have been requested for approval',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              selectApprover()
            },
            reject: () => {

            }
          });
        }
        else {

          selectApprover()
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.SendToApprover, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },

    {
      index: 2, displayName: "Send for processing", click: function (context, event) {

        var itemsApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApproved
        });
        var itemsNotApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApprovalRequested
        });
        if (itemsApproved.length == 0 && itemsNotApproved.length == 0) {
          context.confirmationService.confirm({
            message: 'No Items added have been approved. Are you sure that you would like to continue?',
            header: 'No Items added have been approved',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowApproved;
              context.panelHeader = "Send for processing";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        } else if (itemsNotApproved.length > 0) {
          context.confirmationService.confirm({
            message: 'Not all items have been approved. Are you sure that you would like to continue?',
            header: 'Not all items have been approved',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowApproved;
              context.panelHeader = "Send for processing";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        }
        else {
          context.overlayPanelData = {};
          context.overlayPanelIdentifier = WorkflowType.WorkflowApproved;
          context.panelHeader = "Send for processing";
          context.showActionDialog = true;
        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.SendForProcessing, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 1, displayName: "RFQ", click: function (context, event) {
        const ref = context.dialogService.open(RfqSelectItemsComponent, {
          data: {
            requisitionId: context.entityId,
            items: context.getFormInstanceByIndex(1).items.data
          },
          header: `Send RFQ email`,
          width: '50%'
        });
        ref.onClose.subscribe((emails) => {

        });
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.SendToApprover, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 1, displayName: "Process Requisition", click: function (context, event) {
        var itemsApproved = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
          return o.latestRequisitionItemWorkflow_workflowType == WorkflowType.WorkflowItemApproved
        });

        if (itemsApproved.length == 0) {

          context.confirmationService.confirm({
            message: 'No Items approved. Are you sure that you would like to continue?',
            header: 'No Items approved',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              context.overlayPanelData = {};
              context.overlayPanelIdentifier = WorkflowType.WorkflowProcessed;
              context.panelHeader = "Process Requisition";
              context.showActionDialog = true;
            },
            reject: () => {

            }
          });
        }
        else {
          var itemsNotInStock = context.getFormInstanceByIndex(1).items.data.filter(function (o) {
            return !o.inStock
          });
          context.overlayPanelData = {};
          if (itemsNotInStock.length > 0) {
            const ref = context.dialogService.open(PartialEmailsSelectorComponent, {
              data: {
                requisitionId: context.entityId
              },
              header: `Send PO supplier emails`,
              width: '50%'
            });
            ref.onClose.subscribe((emails) => {
              if (emails) {
                context.overlayPanelData = { sendEmails: true, emails: emails };
              }

              context.overlayPanelIdentifier = WorkflowType.WorkflowProcessed;
              context.panelHeader = "Process Requisition";
              context.showActionDialog = true;
            });

          }
          else {
            context.overlayPanelIdentifier = WorkflowType.WorkflowProcessed;
            context.panelHeader = "Process Requisition";
            context.showActionDialog = true;
          }




        }
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return new RequisitionBladeSetup().isActionHidden(ReqActions.ProcessReq, context, entityId, newItem, formTriggerIndex, entityData);
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 50, displayName: "Print all items", click: function (context) {
        //context.loading = true;
        var links = document.createElement('a');
        document.body.appendChild(links);
        links.download = "";
        links.target = "_blank";
        links.href = context.apiService.appSettings.apiServiceAddress + `/api/requisitionItem/lazyExportProcessedItems/${context.entityId}`;
        links.click();
        document.body.removeChild(links);
        //        var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyExportProcessedItems/"  + serviceCommand.context.entityId}, method: "POST" };
        //var self = context;

        //self.apiService.exec({
        //  endPoint: download,
        //  context: self,
        //  success: function (data) {
        //    const link = document.createElement('a');
        //    link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
        //    link.setAttribute('visibility', 'hidden');
        //    link.click();
        //  },
        //  error: function (error) {
        //    self.loading = false;
        //    self.messageService.danger('Could not Export', 'Action');
        //  }
        //})
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData)
          return;
        if (!context.entityData.latestWorkflow)
          return;
        var workflowsThatCanPrint = [WorkflowType.WorkflowProcessing,
        WorkflowType.WorkflowProcessed,
        WorkflowType.WorkflowCompleted, WorkflowType.WorkflowGRND,
        WorkflowType.WorkflowItemGRND,
        WorkflowType.WorkflowItemPOGenerated,
        WorkflowType.WorkflowItemComplete,
        WorkflowType.WorkflowPartialItemGRND,
        WorkflowType.WorkflowPartialItemPOGenerated]
        return workflowsThatCanPrint.indexOf(context.entityData.latestWorkflow.workflowType) == -1;
      }, icon: "fas fa-print"
    }
    //{
    //  index: 1, displayName: "Complete", click: function (context, event) {
    //    context.overlayPanelData = {};
    //    context.overlayPanelIdentifier = WorkflowType.WorkflowProcessed;
    //    context.panelHeader = "Complete";
    //    context.showActionDialog = true;
    //  },
    //  isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
    //    return new RequisitionBladeSetup().isActionHidden(ReqActions.Complete, context, entityId, newItem, formTriggerIndex, entityData);
    //  }, icon: "fas fa-paper-plane"
    //},








  ]
}

export class RequisitionForm extends entity.RequisitionForm {
  protected requisitionFormEndPoints: RequisitionEndPoints = new RequisitionEndPoints();
  protected requisitionFormFields: RequisitionFormFields = new RequisitionFormFields();
  public onLoaded: Function = function (context: any, entity?: any, isDifferentEntityId?: boolean) {
    if (context.entityId == "00000000-0000-0000-0000-000000000000") {
      context.entityData.organisationId = context.authService.currentOrganisationId;
      context.entityData.division = context.authService.currentOrganisation ? context.authService.currentOrganisation.label : '';
      context.entityData.isPettyCash = false;
      context.loading = true;
      context.apiService.get(`/api/User/currentUserWithContact`)
        .subscribe(user => {
          context.entityData.contactPerson = user.name;
          context.entityData.contactNumber = user.tel;
          context.entityData.deliveryAddress = user.siteAddress;
          context.entityData.siteLookup = user.siteName;
          context.loading = false;
        }, err => {
          context.messageService.danger("Could not load user details", "Action");
          context.loading = false;
        });
      context.entityData.uniqueId = 'New Requisition'
    }
    else {
      if (context.entityData && context.entityData.organisationId && context.entityData.organisationId != '' && context.authService.currentOrganisationId != context.entityData.organisationId) {
        debugger;
        context.messageService.info('Swithing division to ' + context.authService.getOrg(context.entityData.organisationId).label, 'Switching division')
        context.authService._currentOrganisationId = '';
        context.authService.currentOrganisationId = context.entityData.organisationId
      }
      context.entityData.division = context.authService.currentOrganisation ? context.authService.currentOrganisation.label : '';
      try {
        if (isDifferentEntityId && context.entityData.latestWorkflow.comments && context.entityData.latestWorkflow.comments != '') {
          const ref = context.dialogService.open(ActionDialogComponent, {
            data: {
              buttonActions: [
                {
                  iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                    ref.close();
                  }
                }
              ],
              message: `${context.entityData.latestWorkflow.comments}`,
            },
            header: 'Notes captured',
            width: '50%'
          });
        }
        var isReadonly = false;
        if (context.authService.userProfile) {
          if (context.entityData.latestWorkflow && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRejectedForCorrection) {
            if (context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
              if (!context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
                isReadonly = true;//context.makeFormReadOnly(true);
              }
              else isReadonly = false;//context.makeFormReadOnly(false);
            }
            else isReadonly = true;//context.makeFormReadOnly(true);
          } else if (context.entityData.createdByUserId == context.authService.userProfile.sub || context.entityData.linkedUserId == context.authService.userProfile.sub)
            isReadonly = false;//context.makeFormReadOnly(false);
          else isReadonly = true;//context.makeFormReadOnly(true);
          if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
            isReadonly = false;
          context.makeFormReadOnly(isReadonly);
        }
        else {
          context.authService.userProfileObserver.subscribe(o => {
            if (o == null)
              return;
            if (context.entityData.latestWorkflow && (context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated && context.entityData.latestWorkflow.workflowType != WorkflowType.WorkflowRejectedForCorrection)) {
              if (context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || context.entityData.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
                if (!context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
                  isReadonly = true;//context.makeFormReadOnly(true);
                }
                else isReadonly = false;//context.makeFormReadOnly(false);
              }
              else isReadonly = true;//context.makeFormReadOnly(true);
            } else {
              if (context.entityData.createdByUserId == context.authService.userProfile.sub || context.entityData.linkedUserId == context.authService.userProfile.sub)
                isReadonly = false;//context.makeFormReadOnly(false);
              else isReadonly = true;//context.makeFormReadOnly(true);
            }
            if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
              isReadonly = false;
            context.makeFormReadOnly(isReadonly);
          });
        }

      } catch{ }
    }
  }
}

export class RequisitionListColumns extends entity.RequisitionListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.latestRequisitionWorkflowId.visible = false;
      this.organisationId.visible = false;
      this.status.visible = false;
      this.splice(0, this.length);
      var date = FormBuilderControlListHelper.getListColumn("date", "Created on", ViewType.DateTime, null, "date");
      date.viewType = ViewType.DateTime
      date.template = function (t) {
        return (new Date(t)["shortDate"]()).toString();
      }
      date.filterMatchMode = "";
      date.whereExpressionType = WhereExpressionType.DateRange;




      //workflow.formBuilderControl.controlType.viewType = ViewType.Dropdown;
      //workflow.dataEndPoint = { url: app.config.controllerRouteRoot + "/workflow/dropdown/0" };
      //workflow.dataDisplayField = "name";
      //workflow.dataIdField = "name";

      var workflow = FormBuilderControlListHelper.getListColumn("latestRequisitionWorkflowName", "Workflow", ViewType.Dropdown, null, "latestRequisitionWorkflowName");
      workflow.viewType = ViewType.Dropdown;
      workflow.formBuilderControl.lookups = [
        { label: "Created", value: "Created" },
        { label: "Contract Manager Approval Requested", value: "Contract Manager Approval Requested" },
        { label: "Rejected for correction", value: "Rejected for correction" },
        { label: "Procurement Approval requested", value: "Procurement Approval requested" },
        { label: "Rejected for correction to officer", value: "Rejected for correction to officer" },
        { label: "Approval Requested", value: "Approval Requested" },
        { label: "Approved", value: "Approved" },
        { label: "PO Created", value: "PO Created" },
        { label: "Cancelled", value: "Cancelled" },
        { label: "GRN", value: "GRN" },
        { label: "GRN - Completed", value: "GRN - Completed" },
        { label: "Issued to warehouse", value: "Issued to warehouse" },
      ]
      workflow.whereExpressionType = WhereExpressionType.Equals
      date.width = 100;
      this.uniqueId.width = 100;
      this.contactNumber.width = 140;
      var progress = FormBuilderControlListHelper.getListColumn("statusDetail", "Status Detail", ViewType.String, null, "statusDetail");
      progress.width = 100;
      var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionWorkflow", "Progress", ViewType.String, null, "latestRequisitionWorkflow");
      workflowId.visible = false;
      //var officerId = FormBuilderControlListHelper.getListColumn("officerId", "Assigned Officer", ViewType.String, null, "officerId");
      var officer = FormBuilderControlListHelper.getListColumn("assignedOfficer", "Assigned Officer", ViewType.String, null, "assignedOfficer");
      //officer.visible = false;
      var comment = FormBuilderControlListHelper.getListColumn("notes", "Notes", ViewType.String, null, "notes");
      comment.template = function (da) {
        if (da && da.length > 100)
          return da.substring(0, 100) + '...';
        else return da;
      }
      var supplierCodes = FormBuilderControlListHelper.getListColumn("supplierCodes", "Supplier code(s)", null, null, "supplierCodes");
      var suppliers = FormBuilderControlListHelper.getListColumn("supplierNames", "Supplier(s)", null, null, "supplierNames");
      date.viewType = ViewType.DateTime

      var poNumbers = FormBuilderControlListHelper.getListColumn("poNumbers", "PO Number", null, null, "poNumbers");
      var invoiceNos = FormBuilderControlListHelper.getListColumn("invoiceNo", "Invoice / Quote", null, null, "invoiceNo");


      var jobLedger = FormBuilderControlListHelper.getListColumn("jobLedgers", "Job / Ledger", ViewType.String, null, "jobLedgers");
      var poPrinted = FormBuilderControlListHelper.getListColumn("poPrinted", "PO Printed", ViewType.Dropdown, null, "poPrinted");
      poPrinted.formBuilderControl.lookups = [
        { label: "Yes", value: "True" },
        { label: "All", value: "" },
      ]
      poPrinted.template = function (val) {
        if (val && val == true)
          return "Yes";
        else return "";
      }
      poPrinted.visible = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval)
      };
      jobLedger.width = 100;
      poPrinted.width = 100;
      this.push(this.id);
      this.push(date);
      this.push(this.uniqueId);
      this.contactPerson.width = 120;
      this.push(this.contactPerson);
      this.push(supplierCodes);
      this.push(suppliers);
      this.push(jobLedger)
      this.push(this.deliveryAddress);
      this.push(workflow);
      this.push(progress);
      this.push(poPrinted);
      this.push(officer);
      officer.width = 130;
      //this.push(officerId);
      this.push(poNumbers);
      poNumbers.width = 100;
      invoiceNos.width = 100;
      this.push(invoiceNos);
      this.push(comment);

      this.push(workflowId);

      this.forEach(o => {
        if (typeof o.width == "undefined")
          o.width = 100;
      })

      //this.push(FormBuilderControlListHelper.getListColumn("requisitionItems", "Approvals Requested", null, null, "approvalsRequested"));
      //this.push(FormBuilderControlListHelper.getListColumn("requisitionItems", "Approved", null, null, "approved"));
    } catch  { }
  }
}

export class RequisitionList extends entity.RequisitionList {
  protected requisitionListEndPoints: RequisitionEndPoints = new RequisitionEndPoints();
  protected requisitionListColumns: RequisitionListColumns = new RequisitionListColumns();

  public rowHeight: any = 65;
  public init: any = function (context) {
    var _th = this;
    if (context.authService && context.authService.userProfile)
      _th.addStaticFilters(context);
    else
      context.authService.userProfileObserver.subscribe(o => {
        _th.addStaticFilters(context);
      });

  }

  addStaticFilters = function (context) {
    context.staticFilters = new Array();

    if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
      var actionRequired = FormBuilderControlListHelper.getListColumn("", "", ViewType.Dropdown, null, "actionRequired");
      actionRequired.formBuilderControl.lookups = [
        { label: "Action Required", value: "ActionRequiredOfficer" },
        { label: "Action Required assigned to other officer", value: "ActionRequiredOtherOfficers" },
        { label: "All Requisitions", value: "All Requisitions" },
      ]
      actionRequired.default = "ActionRequiredOfficer";
      actionRequired.width = 130;

      context.staticFilters.push({ control: actionRequired.formBuilderControl, filterValue: 'ActionRequiredOfficer', whereFilterType: 1, columnName: "actionRequired" });
      context.showAdvancedFilters = true;
    }
    else {
      var actionRequired = FormBuilderControlListHelper.getListColumn("", "", ViewType.Dropdown, null, "actionRequired");
      actionRequired.formBuilderControl.lookups = [
        { label: "Action Required", value: "ActionRequired" },
        { label: "All Requisitions", value: "All Requisitions" },
      ]
      actionRequired.default = "ActionRequired";
      actionRequired.width = 130;

      context.staticFilters.push({ control: actionRequired.formBuilderControl, filterValue: 'ActionRequired', whereFilterType: 1, columnName: "actionRequired" });
      context.showAdvancedFilters = true;
    }
  }

  //public get staticFilters(): Array<IPropertyFilter> { return new WorkOrderStaticFilters() };
}

export class RequisitionReportActionRequiredListBladeSetup {
  //public menuActions: Array<IDetailComponent> = [
  //	{
  //		index: 0, displayName: "Export Selected", click: function (context) {
  //			var table = context.getFormInstanceByIndex(0).lazyTable;
  //			let filterArr = new Array();


  //			if (table.staticFilters)
  //				table.staticFilters.filter(function (o) {
  //					return o.filterValue != '' && o.filterValue != null
  //				})
  //					.forEach(o => {
  //						filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
  //					});
  //			let filterObject = JSON.parse(table._currentFilterObject);
  //			filterObject.StartCount = 0;
  //			filterObject.PageSize = 9999999;
  //			filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

  //			var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyActionRequiredExport" }, method: "POST" };
  //			var self = context;


  //			self.apiService.exec({
  //				data: filterObject,
  //				endPoint: download,
  //				context: self,
  //				success: function (data) {
  //					const link = document.createElement('a');
  //					link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
  //					link.setAttribute('visibility', 'hidden');
  //					link.click();
  //				},
  //				error: function (error) {
  //					self.loading = false;
  //					self.messageService.danger('Could not Export', 'Action');
  //				}
  //			})
  //		}
  //	},
  //]
}

export class RequisitionActionsRequiredReportEndPoints extends entity.RequisitionEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyActionRequired/" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyActionRequiredCount/" }, method: "POST" };
  exportToExcel?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisition/lazyActionRequiredExport" }, method: "POST" };
}


export class RequisitionListActionsRequiredReportColumns extends entity.RequisitionListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.latestRequisitionWorkflowId.visible = false;
      this.organisationId.visible = false;
      this.status.visible = false;
      this.splice(0, this.length);
      var date = FormBuilderControlListHelper.getListColumn("date", "Created on", ViewType.DateTime, null, "date");
      date.viewType = ViewType.DateTime
      date.template = function (t) {
        return (new Date(t)["shortDate"]()).toString();
      }
      date.filterMatchMode = "";
      date.whereExpressionType = WhereExpressionType.DateRange;


      var latestStatusDate = FormBuilderControlListHelper.getListColumn("latestRequisitionDatestamp", "Latest WF", ViewType.DateTime, null, "latestRequisitionDatestamp");
      latestStatusDate.viewType = ViewType.DateTime
      latestStatusDate.template = function (t) {
        return (new Date(t)["shortDate"]()).toString();
      }
      latestStatusDate.filterMatchMode = "";
      latestStatusDate.whereExpressionType = WhereExpressionType.DateRange;

      //workflow.formBuilderControl.controlType.viewType = ViewType.Dropdown;
      //workflow.dataEndPoint = { url: app.config.controllerRouteRoot + "/workflow/dropdown/0" };
      //workflow.dataDisplayField = "name";
      //workflow.dataIdField = "name";

      var workflow = FormBuilderControlListHelper.getListColumn("latestRequisitionWorkflowName", "Workflow", ViewType.Dropdown, null, "latestRequisitionWorkflowName");
      workflow.viewType = ViewType.Dropdown;
      workflow.formBuilderControl.lookups = [
        { label: "Contract Manager Approval Requested", value: "Contract Manager Approval Requested" },
        { label: "Rejected for correction", value: "Rejected for correction" },
        { label: "Procurement Approval requested", value: "Procurement Approval requested" },
        { label: "Rejected for correction to officer", value: "Rejected for correction to officer" },
        { label: "Approval Requested", value: "Approval Requested" },
      ]

      date.width = 100;
      this.uniqueId.width = 100;
      this.contactNumber.width = 140;
      var progress = FormBuilderControlListHelper.getListColumn("statusDetail", "Status Detail", ViewType.String, null, "statusDetail");
      progress.width = 100;
      var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionWorkflow", "Progress", ViewType.String, null, "latestRequisitionWorkflow");
      workflowId.visible = false;
      var officerId = FormBuilderControlListHelper.getListColumn("assignedOfficer", "Assigned Officer", ViewType.String, null, "assignedOfficer");
      var officer = FormBuilderControlListHelper.getListColumn("assignedOfficer", "Assigned Officer", ViewType.String, null, "assignedOfficer");
      var comment = FormBuilderControlListHelper.getListColumn("notes", "Notes", ViewType.String, null, "notes");
      comment.template = function (da) {
        if (da && da.length > 100)
          return da.substring(0, 100) + '...';
        else return da;
      }
      var suppliers = FormBuilderControlListHelper.getListColumn("supplierNames", "Supplier(s)", null, null, "supplierNames");
      date.viewType = ViewType.DateTime

      var poNumbers = FormBuilderControlListHelper.getListColumn("poNumbers", "PO Number", null, null, "poNumbers");


      var jobLedger = FormBuilderControlListHelper.getListColumn("jobLedgers", "Job / Ledger", ViewType.String, null, "jobLedgers");
      var poPrinted = FormBuilderControlListHelper.getListColumn("poPrinted", "PO Printed", ViewType.Dropdown, null, "poPrinted");
      poPrinted.formBuilderControl.lookups = [
        { label: "Yes", value: "True" },
        { label: "All", value: "" },
      ]
      poPrinted.template = function (val) {
        if (val && val == true)
          return "Yes";
        else return "";
      }
      poPrinted.visible = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval)
      };

      var approverId = FormBuilderControlListHelper.getListColumn("approver.firstName", "Assigned Approver", ViewType.String, null, "approver_displayName");
      var approver = FormBuilderControlListHelper.getListColumn("AssignedApprover", "Assigned Approver", ViewType.String, null, "AssignedApprover");
      var currentWfUser = FormBuilderControlListHelper.getListColumn("currentWfUser", "Currently at", ViewType.String, null, "currentWfUser");

      var invoiceNos = FormBuilderControlListHelper.getListColumn("invoiceNo", "Invoice / Quote", null, null, "invoiceNo");
      this.push(this.id);
      this.push(date);
      this.push(latestStatusDate);
      this.push(workflow);
      this.push(currentWfUser)
      this.push(this.uniqueId);
      this.push(this.contactPerson);
      progress.visible = false;
      this.push(progress);
      this.push(officer);
      //this.push(officerId);
      //this.push(approverId);
      this.push(approver);
      this.push(suppliers);
      this.push(jobLedger)
      this.push(this.deliveryAddress);
      this.push(poPrinted);
      this.push(poNumbers);
      this.push(invoiceNos);
      this.push(comment);
      this.createdByUserId.visible = false;
      this.push(this.createdByUserId)
      this.push(workflowId);

      this.forEach(o => {
        o.width = 150;
      })


      //this.push(FormBuilderControlListHelper.getListColumn("requisitionItems", "Approvals Requested", null, null, "approvalsRequested"));
      //this.push(FormBuilderControlListHelper.getListColumn("requisitionItems", "Approved", null, null, "approved"));
    } catch  { }
  }
}
export class RequisitionReportActionRequiredList extends entity.RequisitionList {
  protected requisitionListEndPoints: RequisitionActionsRequiredReportEndPoints = new RequisitionActionsRequiredReportEndPoints();
  protected requisitionListColumns: RequisitionListActionsRequiredReportColumns = new RequisitionListActionsRequiredReportColumns();
  public customSelect = function (scope, row) {
    const a = document.createElement('a');
    a.href = window.location.origin + '/requisition/index;id_1=' + row.id;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  public disableNavigation: boolean = true;
}
